import { render, staticRenderFns } from "./CalendarGroupModal.vue?vue&type=template&id=1d40b494&scoped=true"
import script from "./CalendarGroupModal.vue?vue&type=script&lang=js"
export * from "./CalendarGroupModal.vue?vue&type=script&lang=js"
import style0 from "./CalendarGroupModal.vue?vue&type=style&index=0&id=1d40b494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d40b494",
  null
  
)

export default component.exports